import script from "./SalesReportNewHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./SalesReportNewHeader.vue?vue&type=script&setup=true&lang=ts"

import "./SalesReportNewHeader.vue?vue&type=style&index=0&id=8fd1420a&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8fd1420a"]])

export default __exports__